import * as Yup from 'yup';

const allowedFileFormats = [
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '',
  /* Apple keynote presentations (.key) has an empty type
   * Not sure if there are other types that are empty
   * as well that could bypass this. If all else fails
   * we have a 30mb limit for files */ 'application/pdf',
];

export const ContactSchema = Yup.object().shape({
  name: Yup.string().required(),
  emailOrPhoneNumber: Yup.string().required(),
  tellUsMore: Yup.string().required(),
});

export const ApplySchema = Yup.object().shape({
  name: Yup.string().required(),
  email: Yup.string().email().required(),
  phoneNumber: Yup.string().required(),
  companyNameOrIdeaName: Yup.string().required(),
  ideaDescription: Yup.string().required(),
  website: Yup.string().notRequired(),
  file: Yup.mixed()
    .nullable()
    .notRequired()
    .test(
      'fileSize',
      'File is too large.',
      (value) => !value || (value && value.size <= 30000000)
    )
    .test(
      'fileFormat',
      'Unsupported file format.',
      (value) =>
        !value ||
        (value && allowedFileFormats.includes(value.type))
    ),
  howDoYouKnowPeopleNeedWhatYouAreMaking: Yup.string().required(),
  whatSubstitutesDoPeopleResortTo: Yup.string().required(),
  howFarAlongAreYou: Yup.string().required(),
  aboutTeam: Yup.string().required(),
  howWillYouMakeMoneyAndHowMuchCouldYouMake: Yup.string().required(),
  howWillYouGetUsers: Yup.string().required(),
  anythingElseWeShouldKnowAboutYourCompany: Yup.string().required(),
});
